import { routes } from '@env/shared-environment/routes';

const PROTECTED_DONATION_SEGMENTS = ['/mine', '/interests', '/messages'];

export function isPublicReadRoute(url: string, method: string): boolean {
  if (method !== 'GET') {
    return false;
  }

  if (url.includes(routes.legal.documents)) {
    return true;
  }

  if (url.includes(routes.categories.base)) {
    return true;
  }

  if (!url.includes(routes.donations.base)) {
    return false;
  }

  if (PROTECTED_DONATION_SEGMENTS.some(segment => url.includes(segment))) {
    return false;
  }

  if (url.includes(routes.donations.stats) || url.includes(routes.donations.categories) || url.includes(routes.donations.recent)) {
    return true;
  }

  return url.endsWith(routes.donations.base) || /\/donations\/\d+(?:\?|$)/.test(url.split('?')[0] ?? url);
}
